import banner from './img/banner.png'
import { TitlePage } from '../TitlePage/TitlePage'
import { TextPage } from '../TextPage/TextPage';
import { ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { useNavigate } from 'react-router-dom';
import "./TariffNotActive.scss"

const TariffNotActive = () => {

      const navigate = useNavigate();

    return (
        <div className='tariff-not-active'>
            <TitlePage
                style={{
                    color: '#888888',
                    maxWidth: '800px',
                    textAlign: 'center'

                }}
                title={'Доступ к сервису ограничен.'}
            />

            <TextPage 
            text='Пополните баланс и активируйте подписку для продолжения работы'
            />

            <ButtonBasic
                green
                onClick={(e) => navigate('/settings/tariff/tariffs')}
                text={"Пополнить баланс"}
            />

            <img className='tariff-not-active__img' src={banner} />
        </div>
    )
}

export default TariffNotActive